import { addCartItem, changeItem } from '@/routes/order';
import { IBestCombo, ICartCombo, ICartComboProduct } from '@/store/ducks/combos/types';
import { IProduct } from '@/store/ducks/products/types';

import { formatToBestCombo, getComboInfo, submitComboPromotion } from '../utils/comboUtils';

export class AddCombosModalController {
  private order: any;

  private product: IProduct | undefined;

  private quantities: Record<number, number>;

  private onClose: () => void;

  constructor(
    order: any,
    product: IProduct | undefined,
    quantities: Record<number, number>,
    onClose: () => void,
  ) {
    this.order = order;
    this.product = product;
    this.quantities = quantities;
    this.onClose = onClose;
  }

  get cart() {
    return this.order?.cart;
  }

  get mainProduct(): IProduct | undefined {
    return this.product;
  }

  get formattedCombo(): IBestCombo | undefined {
    return formatToBestCombo(
      this.cart?.combos?.find((combo: ICartCombo) => combo.id === this.mainProduct?.combo_id),
      this.product,
    );
  }

  get comboInfo() {
    return getComboInfo({ best_combo: this.formattedCombo } as { best_combo: IBestCombo });
  }

  get isProgressive(): boolean {
    return (
      (this.order?.cart.combos
        ?.find((c: ICartCombo) => c?.id === this.mainProduct?.combo_id)
        ?.combo_products?.filter(
          (p: ICartComboProduct) => p?.main_full_product_id === this.mainProduct?.id,
        )?.length ?? 0) > 1
    );
  }

  get comboName(): string | undefined {
    return this.cart?.combos?.find((combo: ICartCombo) => combo.id === this.mainProduct?.combo_id)
      ?.name;
  }

  getProducts = (): any[] | undefined => {
    const comboProducts = this.order?.cart.products.filter(
      (p: IProduct) => p.combo_seq_id && p.combo_id === this.mainProduct?.combo_id,
    );

    if (!comboProducts) return;

    const comboGroups = comboProducts?.reduce((groups: any, product: any) => {
      const comboSeqId = product.combo_seq_id;
      if (!groups[comboSeqId]) {
        groups[comboSeqId] = [];
      }
      groups[comboSeqId]?.push(product);
      return groups;
    }, {} as Record<number, typeof comboProducts>);

    // eslint-disable-next-line consistent-return
    return Object.entries(comboGroups).flatMap(([, products]) => products);
  };

  async handleSubmitComboPromotion(): Promise<void> {
    const result = await submitComboPromotion({
      quantities: this.quantities,
      comboId: this.mainProduct?.combo_id || 0,
      onClose: this.onClose,
      orderId: this.order?.id,
    });

    if (!result.success) {
      console.error('Combo promotion failed:', result.error);
    }
  }

  addComboProduct = (product: IProduct) => {
    const existingProduct = this.order?.cart.products.find(
      (item: any) => item.product_id === product?.product_id && !item.combo_id,
    );

    if (existingProduct) {
      changeItem(this.order?.id as number, {
        ean: product?.ean as string,
        quantity: existingProduct.quantity + 1,
        product_id: product?.product_id as number,
        uid: existingProduct.uid,
      });
      return;
    }

    addCartItem(this.order?.id as number, {
      product_id: product?.product_id,
      quantity: 1,
      ean: product?.ean,
    });
  };
}
